import { Collapse, Divider, notification, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import Container from '../../../../components/Container/Container';
import Screenback from '../../../../components/screenBack/screenBack';
import { getKeyByValue, monthsInYear } from '../../../../utils/settings';
import { getDispatchPlanningReportAction } from '../../action/util_action';
import OrderBookingTable from '../orders/OrderBookingTable';

const { Panel } = Collapse;

const DispatchPlanningUserReports = () => {
  const [userReports, setUserReports] = useState([]);

  const getAlalytics = async () => {
    const { error, data, message } = await getDispatchPlanningReportAction();

    if (!error) {
      setUserReports(data ? data : []);
    } else notification.error({ message: message });
  };

  useEffect(() => {
    getAlalytics();
  }, []);

  return (
    // <Container styles={{ backgroundColor: 'white' }}>
    <div style={{ width: '100%' }} className='userReports'>
      {/* <Screenback /> */}

      <Space direction='vertical' style={{ width: '100%', marginTop: '1rem' }}>
        {Array.isArray(userReports) &&
          userReports.map((report, indexReport) => {
            const tableDataCompany = {
              rows: [
                'Financial Year',
                'PO QTY(Ton)',
                'Dispatched QTY',
                'Open Order QTY',
                'Pending QTY',
                'AVG. Price',
              ],
              tableData: [1].map(() => [
                report.financial_year,
                Number(report.year_wise_total_po_quantity).toFixed(3),
                Number(report.year_wise_total_dispatched_quantity).toFixed(3),
                Number(report.year_wise_total_open_order_quantity).toFixed(3),
                Number(report.year_wise_total_pending_quantity).toFixed(3),
                Number(report.year_wise_average_po_price).toFixed(2),
              ]),
              onRowClick: (index) => {},
            };

            return (
              <Collapse
                defaultActiveKey={['1']}
                expandIcon={() => <div style={{ display: 'none' }} />}
                ghost={true}
              >
                <Panel
                  header={<OrderBookingTable data={tableDataCompany} />}
                  key={indexReport}
                >
                  {report.details.map((i, index) => {
                    const tableData = {
                      rows: [
                        'Date',
                        'PO QTY(Ton)',
                        'Dispatched QTY',
                        'Open Order QTY',
                        'Pending QTY',
                        'AVG. Price',
                      ],
                      tableData: [
                        [
                          ` ${getKeyByValue(monthsInYear, Number(i.month))}`,
                          Number(i.total_po_quantity).toFixed(3),
                          Number(i.total_dispatched_quantity).toFixed(3),
                          Number(i.total_open_orders_quantity).toFixed(3),
                          Number(i.total_pending_quantity).toFixed(3),
                          Number(i.average_price).toFixed(2),
                        ],
                      ],
                      onRowClick: (index) => {},
                    };
                    return (
                      <>
                        <Collapse collapsible='header' bordered={false}>
                          <Panel
                            header={
                              <h4>{`Month: ${getKeyByValue(
                                monthsInYear,
                                Number(i.month),
                              )}, ${i.year}`}</h4>
                            }
                            key={`Month: ${getKeyByValue(
                              monthsInYear,
                              Number(i.month),
                            )}`}
                          >
                            {/* <OrderBookingTable data={tableDataCompany} /> */}
                            <OrderBookingTable data={tableData} />
                          </Panel>
                        </Collapse>
                        <Divider />
                      </>
                    );
                  })}
                </Panel>
              </Collapse>
            );
          })}
      </Space>
    </div>
    // </Container>
  );
};

export default DispatchPlanningUserReports;
